import instance from "../../utils/axios";

// ✅ Save or Update Gallery Image
export const saveGalleryImage = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );
  const response = await instance.post("/churches/gallery/save", formData);
  return response.data;
};

// ✅ Read Gallery
export const readGallery = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );
  const response = await instance.post("/churches/gallery/read", formData);
  return response.data;
};

// ✅ Delete Gallery
export const deleteGallery = async (payload) => {
  const formData = new URLSearchParams();
  formData.append("_id", payload?._id || "");
  const response = await instance.post("/churches/gallery/delete", formData);
  return response.data;
};

// ✅ Update Gallery Image
export const updateGalleryImage = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );
  const response = await instance.post("/churches/gallery/update", formData);
  return response.data;
};
// ✅ Get Image Base64 from URL
export const getImageBase64 = async (imageUrl) => {
  if (!imageUrl) throw new Error("Image URL is required");

  const formData = new URLSearchParams();
  formData.append("url", imageUrl);

  const response = await instance.post("/getimagebase64", formData);
  return response.data; // backend should return { base64: "data:image/..." } or similar
};
